import React from "react";
import { Alert } from "react-bootstrap";
import { useFetch } from "lib/useFetch";
import { AdvertPreviewLayout } from "../../Ads/Adverts/preview/AdvertPreviewLayout";
import { sanitizeHtml } from "utils/sanitizeHtml";
import styles from "../LandingPage.module.scss";

const LANDING_PAGE_PREVIEW_URL = "/research/japi/content/preview/landing_page/";
const IMAGE_PREVIEW_URL = "/research/japi/content/preview/assets/";

export const LandingPagePreview = ({ match }) => {
  const topic = match.params.topic || null;
  const [landingPage, , err] = useFetch(LANDING_PAGE_PREVIEW_URL + topic, null, "GET");
  const parsedLandingPage = tryParseLandingPage(landingPage);

  if (topic === null || err)
    return <Alert variant="warning">Error previewing landing page, please contact support or try again later.</Alert>;
  if (!landingPage || landingPage.length === 0)
    return <Alert variant="warning">Could not find landing page for topic: {topic}</Alert>;

  return (
    <AdvertPreviewLayout>
      <LandingPageBanner {...parsedLandingPage} />
    </AdvertPreviewLayout>
  );
};

const LandingPageBanner = ({ title, html_content, template_style }) => {
  return (
    <div className="landing-page-preview">
      {title && <h2 className={`${styles.title} mb-3`}>{title}</h2>}
      {html_content && (
        <div
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(html_content) }}
          className={`${styles.htmlContent} ${template_style || ''}`}
        />
      )}
    </div>
  );
};

function tryParseLandingPage(landingPage) {
  if (!landingPage || landingPage.length === 0) return null;

  let parsed = { ...landingPage };
  try {
    if (landingPage.html_content) {
      parsed.html_content = landingPage.html_content.replace(
        /src="([^"]+)"/g,
        (match, url) => {
          if (url.startsWith('/') || url.startsWith('http')) return match;
          return `src="${IMAGE_PREVIEW_URL}${url}"`;
        }
      );
    }
  } catch (err) {
    console.warn("Could not parse preview landing page", err);
  }

  return parsed;
}